import React from "react";
import { Table } from "antd";
import { useRouteMatch } from "react-router-dom";
import ActionBtns from "components/ActionBtns/ActionBtns";

const QuestionbanksList = (props) => {
  console.log("QuestionbanksList props", props);
  const { dataSource, permission } = props;
  const { url } = useRouteMatch();
  console.log("exp list item url", url);
  const tableDataSource = [];
  for (let index = 0; index < dataSource.length; index++) {
    let objToPush = {};
    objToPush.id = dataSource[index].id;
    objToPush.title = dataSource[index].title;
    objToPush.code = dataSource[index].code;
    objToPush.program_name = dataSource[index].program_name;
    objToPush.dups_editable =
      dataSource[index].settings.dups_editable === null ||
      dataSource[index].settings.dups_editable === undefined
        ? "Not set"
        : dataSource[index].settings.dups_editable.toString();
    objToPush.actions = (
      <ActionBtns
      edit={permission.questionbank && permission.questionbank.update}
        // delete={true}
        deleted={props.deleted}
        item={dataSource[index]}
        id={dataSource[index].id}
      />
    );
    tableDataSource.push(objToPush);
  }

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
    },
    {
      title: "Program",
      dataIndex: "program_name",
      key: "program_name",
    },
    {
      title: "Dups editable",
      dataIndex: "dups_editable",
      key: "dups_editable",
    },

    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
    },
  ];

  return (
    <Table dataSource={tableDataSource} columns={columns} pagination={false} />
  );
};

export default QuestionbanksList;
